<template>
  <div class="mt-8">
    <v-divider></v-divider>
    <v-row no-gutters class="mt-4">
      <v-btn depressed rounded v-if="unused !== 'back'"
             color="#F2C953"
             width="150px"
             :disabled="!back"
             @click="handleBack()"
      >
        <v-row no-gutters justify="center" align="center">
          <v-icon>chevron_left</v-icon>
          <span class="pl-1">Back</span>
        </v-row>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn depressed rounded v-if="unused !== 'next'"
             class="white--text"
             color="parishonline"
             width="150px"
             :disabled="!next"
             @click="handleNext()"
      >
        <v-row no-gutters justify="center" align="center">
          <span>{{ final ? 'Submit' : 'Next' }}</span>
          <v-icon v-if="!final" class="pl-1">chevron_right</v-icon>
        </v-row>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "NavigationButtons",
    components: {},
    props: {
      unused: {
        type: String,
      },
      back: {
        type: Boolean,
        default: true,
      },
      next: {
        type: Boolean,
        default: true,
      },
      final: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {}
    },
    computed: {},
    methods: {
      handleBack() {
        this.$emit('back');
      },
      handleNext() {
        if (!this.final) {
          this.$emit('next');
        } else {
          this.$emit('submit');
        }
      },
    }
  }
</script>
